module.exports = __webpack_public_path__ + "img/sprout.fe03cc20.svg";